module.exports = __webpack_public_path__ + "img/image28.4d00c90d.png";